import "../styles/Contacto.css";

const Contacto = () => {
  return (
    <>
      <div className="home p-0">
        <div className="container-cookie bannerInicial">
          <div className="row bannerI">
            <div className="col-12 col-md-6 col-image p-0">
              <div
                className="contacto__image-container"
                style={{ background: "white" }}
              >
                <img
                  src="/assets/img/homeout/img-contacto.png"
                  className="home__image_contact"
                  alt=""
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-back div__contacto">
              <div className="d-block d-lg-none">
                <h1 className="titulo__contacto">Contáctanos</h1>
              </div>
              <div className="home__text-container container__contacto">
                <div className="card__contacto-item">
                  <div className="card__contacto-img d-none d-lg-block">
                    <img
                      src="/assets/img/homeout/contacto/ico-fono.svg"
                      alt="icono_telefono"
                      className="d-none d-lg-block"
                    />
                  </div>
                  <div className="div__telefono">
                    <p className="card__contacto-description">
                      Si tienes alguna inquietud o consulta, comunícate con
                      nosotros en nuestra línea de atención en:
                    </p>
                    <div className="d-lg-none d-block">
                      <br />
                    </div>
                    <p
                      className="card__contacto-description container__contacto__tel-mail"
                      style={{
                        color: "var(--principal)",
                        fontFamily: "var(--fuente-bold)",
                        fontSize: "1.9rem",
                      }}
                    >
                      <div className="d-lg-block d-none">
                        Línea de atención Cardif:{" "}
                        <span style={{ color: "var(--rojo)" }}>
                          <div className="d-lg-none d-block"></div>800 801 2400
                        </span>
                      </div>
                      <div className="d-lg-none d-block">
                        Línea de atención Cardif:{" "}
                        <a href="tel:8008012400" style={{ color: "var(--rojo)", textDecoration: "none" }}>
                          <div className="d-lg-none d-block"></div>800 801 2400
                        </a>
                        <br />
                      </div>
                      <div className="breakLine"></div>
                      <p className="d-none d-md-block">Horarios de atención:</p>
                      <p className="d-md-none">Horarios:</p>
                      {" "}
                      <div className="d-lg-none d-block"></div>Lunes a viernes de 08:00 a 21:00 hrs. <br/>
                      <div className="d-lg-none d-block"></div>Sábados de 09:00 a 18:00 hrs.
                    </p>
                  </div>
                </div>
                <div className="card__contacto-item">
                  <div className="card__contacto-img d-none d-lg-block">
                    <img
                      src="/assets/img/homeout/contacto/ico-correo.svg"
                      alt="icono_correo"
                      className="d-none d-lg-block"
                    />
                  </div>
                  <div>
                    <p className="card__contacto-description">
                      También puedes escribirnos a
                    </p>
                    <p className="card__contacto-description">
                      nuestro correo electrónico:
                    </p>
                    <p
                      className="card__contacto-description"
                      style={{
                        color: "var(--rojo)",
                        fontFamily: "var(--fuente-bold)",
                        paddingTop: "1rem",
                        fontSize: "2rem",
                      }}
                    >
                      <a
                        href="mailto:sac_mx@cardif.com.mx"
                        style={{ color: "var(--principal)", textDecoration: "none" }}
                      >
                        sac_mx@cardif.com.mx
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contacto;
